import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Popconfirm,
  Row,
  Skeleton,
} from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  createUser,
  deleteUser,
  getUser,
  updateUser,
} from "../../actions/users";
import { useNavigate, useParams } from "react-router-dom";

const Customer = ({ currentUser }) => {
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [, forceUpdate] = useState({});
  const { id } = useParams();
  const user = useSelector((state) => state?.users);

  const dispatch = useDispatch();
  const history = useNavigate();
  const [form] = Form.useForm();

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    forceUpdate({});
    if (id) {
      dispatch(getUser(id));
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      name: user?.name,
      email: user?.email,
      phone: user?.phone,
      country: user?.country,
      role: user?.role,
    });
  }, [form, user]);

  const onFinish = (value) => {
    if (id) {
      setLoadingButton(true);
      const formData = {
        ...value,
        role: "CUSTOMER",
      };
      dispatch(updateUser(id, formData, history, setLoadingButton));
      // history("/customers");
      // message.success("Customer updated successfully");
    } else {
      setLoadingButton(true);
      const formData = {
        ...value,
        role: "CUSTOMER",
        store: currentUser.store,
      };
      dispatch(createUser(formData, history, setLoadingButton));
    }
  };

  const deleteUserFun = () => {
    dispatch(deleteUser(id, history));
  };

  return (
    <Dashboard title={`${id ? "View" : "Add"} Customer`}>
      <div className="p-4 shadow bg-white mt-2 mb-6 flex items-center justify-between">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/customers">Customers</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{`${id ? "View" : "Add"} Customer`}</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        form={form}
        autoComplete="off"
      >
        <div className="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div className="mt-5 md:mt-0 md:col-span-2 px-4 py-5 sm:p-6 bg-white shadow">
            <Skeleton loading={loading}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      { required: true, message: "Please input user name!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Please input user email!" },
                    ]}
                  >
                    <Input type="email" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Phone"
                    name="phone"
                    rules={[
                      { required: true, message: "Please input user phone!" },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                </Col>
              </Row>
            </Skeleton>
          </div>
          <div className="md:col-span-1">
            <div className="bg-white shadow px-4 py-5 sm:p-6">
              <Skeleton loading={loading}>
                <Row gutter={16}>
                  <Col span={24}>
                    <div className="flex flex-wrap  justify-start gap-4">
                      <Button href="/users">Cancel</Button>
                      <Form.Item shouldUpdate style={{ marginBottom: 0 }}>
                        {() => (
                          <Button
                            type="primary"
                            htmlType="submit"
                            disabled={
                              !form.isFieldsTouched(true) ||
                              !!form
                                .getFieldsError()
                                .filter(({ errors }) => errors.length).length
                            }
                            loading={loadingButton}
                          >
                            {`${id ? "Update" : "Save"} Customer`}
                          </Button>
                        )}
                      </Form.Item>
                      {id ? (
                        <Popconfirm
                          title="Are you sure to delete this user?"
                          onConfirm={deleteUserFun}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button danger type="primary">
                            Delete
                          </Button>
                        </Popconfirm>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
              </Skeleton>
            </div>
          </div>
        </div>
      </Form>
    </Dashboard>
  );
};

export default Customer;
